import React from 'react';

import { JsonEditor } from 'json-edit-react';
interface FeedBlueprintEditorProps<T> {
  data: T;
  onUpdate: (newData: T) => void;
}

export default function FeedBlueprintEdito<T extends object>(props: FeedBlueprintEditorProps<T>) {
  return (
    <div>
      <JsonEditor
        data={props.data}
        onUpdate={evt => {
          props.onUpdate(evt.newData as T);
        }}
      />
    </div>
  );
}
